"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Layout_1 = __importDefault(require("@comp/Layout"));
const markdown_style_module_css_1 = __importDefault(require("@/styles/markdown-style.module.css"));
const error_1 = __importDefault(require("@views/error"));
const PostNavigation_1 = __importDefault(require("@comp/PostNavigation"));
const utterances_1 = __importDefault(require("@comp/utterances"));
const TableOfContents_1 = __importStar(require("@comp/TableOfContents"));
const posts_1 = require("@/api/posts");
const formatDate_1 = require("@/util/formatDate");
const gray_matter_1 = __importDefault(require("gray-matter"));
const marked = __importStar(require("marked"));
const highlight_js_1 = __importDefault(require("highlight.js"));
require("./highlight.scss");
async function Post() {
    const path = window.location.pathname;
    const postId = path.split("/").pop(); // URL의 마지막 부분을 postId로 사용합니다.
    // posts.json에서 올바른 파일명을 찾기
    let postContentURL;
    let navigationHtml;
    try {
        const posts = await (0, posts_1.getAllPosts)();
        const post = posts.find((p) => p.path === path);
        navigationHtml = (0, PostNavigation_1.default)(posts.filter((p) => p.public), path);
        if (post) {
            // path에서 파일명 추출 (예: "/posts/1-compile" -> "1-compile")
            const fileName = post.path.split("/").pop();
            postContentURL = `/content/posts/${fileName}.md`;
        }
        else {
            throw new Error(`Post not found for path: ${path}`);
        }
    }
    catch (error) {
        console.error("Failed to load posts.json", error);
        return (0, error_1.default)();
    }
    let postContent;
    try {
        const response = await fetch(postContentURL);
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        postContent = await response.text();
    }
    catch (error) {
        console.error("failed to fetch post content", error);
        return (0, error_1.default)();
    }
    // gray-matter를 사용하여 프론트매터와 마크다운 본문을 분리
    const { data: frontMatter, content: markdownContent } = (0, gray_matter_1.default)(postContent);
    // marked를 사용하여 마크다운을 HTML로 변환
    const htmlContent = marked.marked(markdownContent);
    const rawHtml = document.createElement("div");
    rawHtml.innerHTML = htmlContent;
    rawHtml.querySelectorAll("pre code").forEach((block) => {
        highlight_js_1.default.highlightElement(block);
    });
    rawHtml.querySelectorAll("table").forEach((table) => {
        const wrapper = document.createElement("div");
        wrapper.className = markdown_style_module_css_1.default["tableWrapper"];
        table.replaceWith(wrapper);
        wrapper.appendChild(table);
    });
    const tocItems = [];
    rawHtml.querySelectorAll("h2, h3").forEach((heading, index) => {
        heading.id = `heading-${index}`;
        tocItems.push({
            id: heading.id,
            text: heading.textContent ?? "",
            level: heading.tagName === "H2" ? 2 : 3,
        });
    });
    const toc = (0, TableOfContents_1.default)(tocItems);
    // 이미지 Lazy Loading 및 애니메이션 적용
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const img = entry.target;
                img.classList.remove("opacity-0");
                img.classList.add("opacity-100");
                observer.unobserve(img);
            }
        });
    });
    rawHtml.querySelectorAll("img").forEach((img) => {
        img.setAttribute("loading", "lazy");
        img.classList.add("opacity-0", "transition-opacity", "duration-1000");
        observer.observe(img);
    });
    const readingMinutes = Math.max(1, Math.round((rawHtml.textContent ?? "").length / 500));
    document.title = `영범 블로그 | ${frontMatter.title}`;
    const content = `
  <section class="w-full p-4">
  <div class="text-7xl">${frontMatter.emoji}</div>
    <header class="mt-4">
      <a href="/posts?category=${encodeURIComponent(frontMatter.categories)}" data-link class="text-accent hover:underline inline-block text-body-bold font-GmarketSansMedium">${frontMatter.categories}</a>
      <div class="text-title mt-2">${frontMatter.title}</div>
      <div class="text-muted text-caption1 pt-2">${(0, formatDate_1.formatDate)(frontMatter.date)} · 약 ${readingMinutes}분</div>
    </header>
    <hr class="mt-6 mb-6 border-0 border-t border-solid border-line"/>
    ${toc.inline}
    ${toc.side}
    <div class=${markdown_style_module_css_1.default["markdown"]}>${rawHtml.innerHTML}</div>
    ${navigationHtml}
    <div id="post-comments" class="mt-12"></div>
  </section>`;
    const layoutElement = (0, Layout_1.default)(content);
    document.body.appendChild(layoutElement);
    // 해시 이동은 popstate를 일으켜 라우터가 페이지를 다시 그리므로 직접 스크롤한다
    layoutElement.addEventListener("click", (e) => {
        const link = e.target.closest("a[data-toc]");
        if (!link)
            return;
        e.preventDefault();
        layoutElement
            .querySelector(`#${link.dataset.toc}`)
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    (0, TableOfContents_1.setupTocHighlight)(layoutElement, tocItems);
    (0, utterances_1.default)("y-baaam/VanillaJS-Blog-Project", "comment", "post-comments");
    layoutElement.querySelectorAll("img").forEach((img) => {
        observer.observe(img);
    });
    return layoutElement;
}
exports.default = Post;
